import React, { useState, useEffect } from "react";
import Loading from "../../../../../Common/Loading/Loading";
import { Col, Row, Button } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import * as SixbellGlrDefaultParametersService from "../../../../../../service/SixbellGlrDefaultParametersService";
import { ErrorUnexpected, OperationSuccessfully } from "../../../../../../const/Messages";

const initialValues = {
  id: "",
  ignoredCasesLog: false,
  ignoredCasesIr21: false,
  glrOnlyCheckWithIR21: false,
  glrWlOnlyCheckWithIR21: false,
};

/**
  @author Guilherme Almeida
  @date 26/10/2021
 */
export default function SixbellGlrDefaultParameters() {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [values, setValues] = useState(initialValues);

  useEffect(() => {
    SixbellGlrDefaultParametersService.getSixbellGlrDefaultParameters()
        .then((itens) => {
          setValues(itens);
          setLoading(false);
        })
        .catch(() => {
          history.push("/", { message: ErrorUnexpected, messageType: "error" });
        });
  }, []); // eslint-disable-line

  const schema = Yup.object().shape({});

  function handleSave(values, actions) {

    SixbellGlrDefaultParametersService.update(values)
      .then(() => {
        history.push("/settings/report/template/glr/sixbell/default", { message: OperationSuccessfully, messageType: "success" });
      })
      .catch((error) => {
        if (!error || !error.response || !error.response.data) {
          actions.setFieldError("olnyCheckWithIR21", ErrorUnexpected);
        } else if (error.response.data.title) {
          actions.setFieldError("olnyCheckWithIR21", error.response.data.title);
        }
        actions.setSubmitting(false);
      });
  }

  if (loading) {
    return <Loading />;
  }

  return (
    <Row>
      <Col>
        <div className="ibox">
          <div className="ibox-title">
            <h5>Sixbell GLR Default Parameters</h5>
          </div>
          <div className="ibox-content">
            <Formik initialValues={values} validationSchema={schema} onSubmit={handleSave}>
              {() => (
                <Form>
                  <div className="font-weight-bold pt-2 pb-2"><label>GENERAL</label></div>
                  <div className="form-group row">
                    <label
                      htmlFor="ignoredCases"
                      className="col-form-label col-sm-12 col-md-4 col-lg-4 col-xl-3 col-xxl-1"
                    >
                      Ignored Cases:
                    </label>
                    <div className="col-sm-12 col-md-8 col-lg-6 col-xl-4">
                      <div className="d-flex align-items-baseline">
                        <Field type="checkbox" name="ignoredCasesLog"/>
                          <label className="form-check-label pl-2">
                            Ignore value from LOG.
                          </label>
                        <span className="text-danger">
                          <ErrorMessage name="ignoredCasesLog" />
                        </span>
                      </div>
                      <div className="d-flex align-items-baseline">
                        <Field type="checkbox" name="ignoredCasesIr21" />
                        <label className="form-check-label pl-2">
                          Ignore value from IR21.
                        </label>
                        <span className="text-danger">
                          <ErrorMessage name="ignoredCasesIr21" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="hr-line-dashed"></div>
                  <div className="font-weight-bold pt-2 pb-2"><label>GLR</label></div>
                  <div className="form-group row">
                    <label
                      htmlFor="glrOnlyCheckWithIR21"
                      className="col-form-label col-sm-12 col-md-4 col-lg-4 col-xl-3 col-xxl-1"
                    >
                      IR.21:
                    </label>
                    <div className="col-sm-12 col-md-8 col-lg-6 col-xl-4">
                      <Field type="checkbox" name="glrOnlyCheckWithIR21" />
                      <label className="form-check-label pl-2">
                        Check fields only if IR21 file exists.
                      </label>
                      <span className="text-danger">
                        <ErrorMessage name="glrOnlyCheckWithIR21" />
                      </span>
                    </div>
                  </div>
                  <div className="hr-line-dashed"></div>
                  <div className="font-weight-bold pt-2 pb-2"><label>GLR - WL</label></div>
                  <div className="form-group row">
                    <label
                      htmlFor="glrWlOnlyCheckWithIR21"
                      className="col-form-label col-sm-12 col-md-4 col-lg-4 col-xl-3 col-xxl-1"
                    >
                      IR.21:
                    </label>
                    <div className="col-sm-12 col-md-8 col-lg-6 col-xl-4">
                      <Field type="checkbox" name="glrWlOnlyCheckWithIR21" />
                      <label className="form-check-label pl-2">
                        Check fields only if IR21 file exists.
                      </label>
                      <span className="text-danger">
                        <ErrorMessage name="glrWlOnlyCheckWithIR21" />
                      </span>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end">
                    <Link className="mr-1 btn btn-primary" to="/settings">
                      Cancel
                    </Link>
                    <Button variant="primary" type="submit">
                      Update
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </Col>
    </Row>
  );
}
